import { Button } from "@capacit-com/lara-law-shared-ui";
import { ArrowDown, ArrowUp, ChevronsUpDown } from "lucide-react";
import { cn } from "@/lib/utils";

interface SortableTableHeaderProps<TSortBy extends string> {
  label: string;
  sortBy: TSortBy;
  activeSortBy: TSortBy;
  ascending: boolean;
  onSort: (sortBy: TSortBy) => void;
  className?: string;
}

/**
 * Column header that sorts the table. Clicking the active column flips the direction.
 * Sorting is applied to the whole result set, not just the page on screen.
 */
export const SortableTableHeader = <TSortBy extends string>({
  label,
  sortBy,
  activeSortBy,
  ascending,
  onSort,
  className,
}: SortableTableHeaderProps<TSortBy>) => {
  const isActive = activeSortBy === sortBy;

  return (
    <Button
      variant="ghost"
      size="sm"
      className={cn("-ml-3 h-8", className)}
      onClick={() => onSort(sortBy)}
      aria-label={`Sortér efter ${label.toLowerCase()}`}
    >
      <span>{label}</span>
      {!isActive ? (
        <ChevronsUpDown className="ml-1 h-3.5 w-3.5 text-muted-foreground/70" />
      ) : ascending ? (
        <ArrowUp className="ml-1 h-3.5 w-3.5" />
      ) : (
        <ArrowDown className="ml-1 h-3.5 w-3.5" />
      )}
    </Button>
  );
};
